import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { AppThunk } from '../store.types';

type BrbItem = { label: string; pairs_str: string };

interface BrbState {
  isLoading: boolean;
  error: string | null;
  items: BrbItem[];
  count: number;
  page: number;
  page_size: number;
  next: string | null;
  previous: string | null;
}

const initialState: BrbState = {
  isLoading: false,
  error: null,
  items: [],
  count: 0,
  page: 1,
  page_size: 20,
  next: null,
  previous: null,
};

const slice = createSlice({
  name: 'brb',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getListSuccess(
      state,
      action: PayloadAction<{
        results: BrbItem[];
        count: number;
        page: number;
        page_size: number;
        next: string | null;
        previous: string | null;
      }>
    ) {
      state.isLoading = false;
      state.items = action.payload.results;
      state.count = action.payload.count;
      state.page = action.payload.page;
      state.page_size = action.payload.page_size;
      state.next = action.payload.next;
      state.previous = action.payload.previous;
    },
  },
});

export const { startLoading, hasError, getListSuccess } = slice.actions;
export default slice.reducer;

export const getBrbList =
  (params?: { search?: string; page?: number; page_size?: number }): AppThunk =>
  async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      const { page_size: currentSize } = (getState() as any).brb as BrbState;
      const q = new URLSearchParams();
      if (params?.search) q.set('search', params.search);
      q.set('page', String(params?.page ?? 1));
      q.set('page_size', String(params?.page_size ?? currentSize ?? 20));

      const res = await axios.get(`/api/v1/brb/lists/?${q.toString()}`);
      // API returns: {count,page,page_size,next,previous,results:[{label,pairs_str}]}
      dispatch(
        getListSuccess({
          results: res.data.results ?? [],
          count: res.data.count ?? 0,
          page: res.data.page ?? 1,
          page_size: res.data.page_size ?? (params?.page_size ?? currentSize ?? 20),
          next: res.data.next ?? null,
          previous: res.data.previous ?? null,
        })
      );
    } catch (err: any) {
      dispatch(hasError(err?.message ?? String(err)));
    }
  };
